/* eslint-disable jsx-a11y/anchor-is-valid */
import * as React from 'react'

import {
  Box,
  Button,
  Modal,
  Space,
  TextBody,
  TextHeading,
  useModalContext,
} from '@ally/metronome-ui'

const headingRef = React.createRef<HTMLHeadingElement>()

const Content: React.FC = () => (
  <>
    <Space mb="md">
      <TextHeading tag="h1" size="lg" tabIndex={-1} ref={headingRef}>
        Message and Data Rates
      </TextHeading>
    </Space>
    <TextBody size="sm" tag="p">
      We don&apos;t charge a message delivery fee, but your carrier may charge
      standard message and data rates.
    </TextBody>
    <TextBody size="sm" tag="p">
      Check your plan or contact your carrier if you have questions about text
      message rates.
    </TextBody>
  </>
)

const Trigger: React.FC = () => {
  const { setOpen } = useModalContext()
  return (
    <Box mb={2}>
      <Button
        variant="link"
        text="Message and data rates may apply"
        onClick={(): void => setOpen(true)}
      />
    </Box>
  )
}

export const MessageAndDataModal: React.FC = () => {
  return <Modal content={<Content />} height="200px" trigger={<Trigger />} />
}

export default MessageAndDataModal
